import type {
    SearchSuggestion,
    ResultCardItem,
} from '@comfama/comfama-ui-react';

import { ElasticSearchResult } from '../hooks/useElasticSearch';

export const transformElasticSuggestion = (
    results: ElasticSearchResult[]
): SearchSuggestion[] => {
    return results.map((result) => {
        const elasticResult = result;
        return {
            id: elasticResult.id || '',
            title: elasticResult.title,
            description: elasticResult.description,
            icon: elasticResult.iconType,
            slug: elasticResult.slug,
            origin: elasticResult.origin,
        };
    });
};

export const transformElasticResults = (
    results: ElasticSearchResult[],
    optimizedAssetsList: Record<string, string>
): ResultCardItem[] => {
    return results.map((result) => {
        const elasticResult = result;
        const originalUrl = elasticResult.urlImageCard || '';
        const optimizedUrl = optimizedAssetsList[originalUrl];
        const origin =
            elasticResult.origin.charAt(0).toUpperCase() +
            elasticResult.origin.slice(1);
        return {
            title: elasticResult.title,
            description: elasticResult.description,
            image: optimizedUrl || originalUrl,
            category:
                origin +
                ' / ' +
                (Array.isArray(elasticResult.category)
                    ? elasticResult.category?.[0]
                    : elasticResult.category || ''),
            // Elasticsearch solo entrega tags como texto plano (sin icono
            // propio), así que se mapean a ResultCardTag con icon vacío.
            tags: elasticResult.dynamicFields || [],
            slug: elasticResult.slug,
            origin: elasticResult.origin,
        };
    });
};
